import { Dialog, DialogTitle } from '@mui/material';

import ChangeRequestForm from './ChangeRequestForm';

interface ChangeRequestDialogProps {
  open: boolean;
  onClose: () => void;
  code: string;
}

const ChangeRequestDialog = ({
  open,
  onClose,
  code,
}: ChangeRequestDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Відправити запит на доопрацювання</DialogTitle>
      <ChangeRequestForm code={code} onSuccess={onClose} />
    </Dialog>
  );
};

export default ChangeRequestDialog;
